import axios, { AxiosRequestConfig, HttpStatusCode } from 'axios';
import _ from 'lodash';

export default class Service {
    baseUrl: string;
    config: AxiosRequestConfig;

    constructor(baseUrl: string, headers: any) {
        this.baseUrl = baseUrl;
        this.config = {
            headers
        };
    }

    async get(url: string, options?: any) {
        try {
            return await axios.get(this.baseUrl + url, this.getConfig(options));
        }
        catch (err: any) {
            return this.getError(err);
        }
     }

    async post(url: string, data: any, options?: any) {
        try {
            return await axios.post(this.baseUrl + url,
                data,
                this.getConfig(options)
            );
        }
        catch (err: any) {
            return this.getError(err);
        }
    }

    async put(url: string, data: any, options?: any) {
        try {
            return await axios.put(this.baseUrl + url,
                data,
                this.getConfig(options)
            );
        }
        catch (err: any) {
            return this.getError(err);
        }
    }

    getConfig(options?: any) {
        if (options) {
            return _.merge({}, this.config, options);
        }
        return this.config;
    }
    
    getOptionalQueryParam(isFirst: boolean, name: string, value?: string) {
        return value ? `${isFirst ? "?" : "&"}${name}=${encodeURIComponent(value)}` : '';
    }

    getError(err: any) {
        console.error(err);
        return err.response ?? { status: HttpStatusCode.ServiceUnavailable };
    }

    IsSuccessStatusCode (status: number): boolean {
        if (status >= 200 && status < 300) {
            return true;
        }
        
        return false;
    }
}
